import { render } from "./LogoImage.vue?vue&type=template&id=fe4d1624&scoped=true"
import script from "./LogoImage.vue?vue&type=script&lang=js"
export * from "./LogoImage.vue?vue&type=script&lang=js"

import "./LogoImage.vue?vue&type=style&index=0&id=fe4d1624&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe4d1624"]])

export default __exports__